// /dashboard/:orgSlug — the overview a signed-in user lands on.
// Figma frames 07 loaded (33:1087), 08 loading (33:2208), 09 empty (33:2743).
// Owner: screens-shell, US-100 to US-102.
//
// The shell, the access check and the sign-out binding all moved up into
// `routes/_shell.tsx` in Wave 3 (US-152). They were correct here and wrong
// only in being here: seventeen copies of one shell remount it on every
// navigation, and the sixteen screens that never had the access check rendered
// their panels for a signed-out caller.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { OverviewScreen } from "../screens/overview";

export const dashboardRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug",
  staticData: { title: "Overview" },
  component: DashboardRoute,
});

function DashboardRoute() {
  const { orgSlug } = dashboardRoute.useParams();
  return <OverviewScreen orgSlug={orgSlug} />;
}
